import axios from 'axios';
import ReactPaginate from 'react-paginate';
import React, { Component } from 'react';
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';

const urlListarOrden = ApiUrl + "ordendocumentolist?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCarreras = ApiUrl + "listarcarreras?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlDocumentos = ApiUrl + "documentos-practicas?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlReportDocumentoTitulacion = ApiUrl + "reporte-documentos-practicas?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModificarDocPracticas = ApiUrl + "modificardocumentpracticas?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCambiarEstDocumentoPracticas = ApiUrl + "updatestadodocumentpracticas?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

const itemsPerPage = 10;

export default class GestionDocumentPractLaborales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            documentosReporte: [],
            documentosBackup: [],
            carreras: [],
            ordendoclist: [],
            carreraSeleccionada: null,
            modalRegistro: false,
            modalModificarPractica: false,
            nombre: "",
            descripcion: "",
            archivo: null,

            // variables de búsqueda y paginación
            filtered: null,
            isFiltering: false,
            savedOffsetBeforeFilter: 0,
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
        };
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }

    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalRegistro: false, modalModificarPractica: false });
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        this.listarCarreras();
        this.listarOrdenes();
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
    };

    listarCarreras = () => {
        axios.get(urlCarreras).then((res) => {
            this.setState({ carreras: res.data });
        });
    };

    listarOrdenes = () => {
        axios.get(urlListarOrden).then((res) => {
            const ordendoclist = res.data.data || [];
            this.setState({ ordendoclist });
        });
    };

    // ================= CRUD =================
    ingresarDocumento = () => {
        const { archivo, nombre, descripcion, carreraSeleccionada, ord_doc_id } = this.state;

        if (!archivo) {
            swal("Error", "Debe seleccionar un archivo", "error");
            return;
        }
        if (!carreraSeleccionada || !ord_doc_id) {
            swal("Error", "Debe seleccionar carrera y orden del documento", "error");
            return;
        }

        const formData = new FormData();
        formData.append("nom_doc", nombre || "");
        formData.append("desc_doc", descripcion || "");
        formData.append("arch_doc", archivo);
        formData.append("car_id", carreraSeleccionada);
        formData.append("ord_doc_id", ord_doc_id);

        axios
            .post(urlDocumentos, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((res) => {
                swal("Éxito", res.data.message || "Documento registrado", "success");
                this.setState({
                    modalRegistro: false,
                    archivo: null,
                    nombre: "",
                    descripcion: "",
                    ord_doc_id: null,
                });
                this.reporteDocumentos(carreraSeleccionada);
            })
            .catch((error) => {
                console.error("Error al registrar documento:", error.response || error);
                swal("Error", "No se pudo registrar el documento", "error");
            });
    };

    reporteDocumentos = (idCarrera) => {
        axios
            .post(urlReportDocumentoTitulacion, { car_id: idCarrera })
            .then((res) => {
                if (res.data.success) {
                    const documentosReporte = Array.isArray(res.data.data)
                        ? res.data.data
                        : [];
                    const itemOffset = 0;
                    const endOffset = itemOffset + itemsPerPage;
                    const currentItems = documentosReporte.slice(itemOffset, endOffset);
                    const pageCount = Math.ceil(documentosReporte.length / itemsPerPage);
                    this.setState({
                        documentosReporte,
                        documentosBackup: [...documentosReporte],
                        currentItems,
                        pageCount,
                        itemOffset,
                    });
                }
            })
            .catch((error) => {
                console.error("Error al generar reporte:", error);
                swal("Error", "No se pudo generar el reporte", "error");
                this.setState({
                    documentosReporte: [],
                    documentosBackup: [],
                    currentItems: [],
                    pageCount: 0,
                });
            });
    };

    bttActDesac = (documento) => {
        let nuevoEstado = documento.estado === 0 ? 1 : 0;

        axios
            .post(urlCambiarEstDocumentoPracticas, {
                idDocumentoPractica: documento.id,
                estado: nuevoEstado,
            })
            .then((response) => {
                if (response.data.status === "success") {
                    this.reporteDocumentos(this.state.carreraSeleccionada);
                } else {
                    swal("Error", "No se pudo actualizar el estado", "error");
                }
            })
            .catch((error) => {
                console.error("Error al actualizar estado:", error);
                swal("Error", "Error en la petición", "error");
            });
    };

    modificarDocumentoPractica = () => {
        const {
            idDocumentoMod,
            idOrdenDocMod,
            nomDocumentMod,
            descripDocumentMod,
            documentoMod,
        } = this.state;

        const formData = new FormData();
        formData.append("id_documento", idDocumentoMod);
        formData.append("id_orden_documento", idOrdenDocMod);
        formData.append("nom_doc", nomDocumentMod);
        formData.append("desc_doc", descripDocumentMod);

        if (documentoMod) {
            formData.append("arch_doc", documentoMod);
        }

        axios
            .post(urlModificarDocPracticas, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
                if (response.data.success) {
                    swal("Éxito", "Documento modificado correctamente", "success");
                    this.setState({ modalModificarPractica: false, documentoMod: null });
                    this.reporteDocumentos(this.state.carreraSeleccionada);
                } else {
                    swal("Error", response.data.message || "No se pudo modificar", "error");
                }
            })
            .catch((error) => {
                console.error("Error al modificar documento:", error);
                swal("Error", "No se pudo conectar con el servidor", "error");
            });
    };

    // ================= MODALES =================
    mostrarModalRegistro = () => {
        this.setState({
            modalRegistro: true,
            nombre: "",
            descripcion: "",
            archivo: null,
            ord_doc_id: "",
        });
    };

    mostrarModalModificarPractica = (documento) => {
        this.setState({
            idDocumentoMod: documento.id,
            idOrdenDocMod: documento.ord_doc_id,
            nomDocumentMod: documento.nom_doc,
            descripDocumentMod: documento.desc_doc,
            documentoMod: null,
            modalModificarPractica: true,
        });
    };

    // ================= BÚSQUEDA =================
    filter(e) {
        const text = e.target.value || "";
        const q = text.trim().toUpperCase();
        const base = this.state.documentosReporte || [];

        if (q) {
            const saved = this.state.isFiltering
                ? this.state.savedOffsetBeforeFilter
                : this.state.itemOffset;

            const filtered = base.filter((it) => {
                const nom = (it.nom_doc || "").toUpperCase();
                const des = (it.desc_doc || "").toUpperCase();
                return nom.includes(q) || des.includes(q);
            });

            this.setState(
                {
                    filtered,
                    isFiltering: true,
                    savedOffsetBeforeFilter: saved,
                    itemOffset: 0,
                    textBuscar: text,
                },
                this.paginar
            );
        } else {
            const total = base.length;
            const maxOffset = Math.max(
                0,
                (Math.ceil(total / itemsPerPage) - 1) * itemsPerPage
            );
            let restored = this.state.savedOffsetBeforeFilter || 0;
            if (restored > maxOffset) restored = maxOffset;

            this.setState(
                {
                    filtered: null,
                    isFiltering: false,
                    itemOffset: restored,
                    textBuscar: "",
                },
                this.paginar
            );
        }
    }

    paginar = () => {
        const base =
            this.state.isFiltering && Array.isArray(this.state.filtered)
                ? this.state.filtered
                : this.state.documentosReporte;

        const { itemOffset } = this.state;
        const endOffset = itemOffset + itemsPerPage;
        const currentItems = base.slice(itemOffset, endOffset);
        const pageCount = Math.ceil(base.length / itemsPerPage);
        this.setState({ currentItems, pageCount });
    };

    handlePageClick = (event) => {
        const base =
            this.state.isFiltering && Array.isArray(this.state.filtered)
                ? this.state.filtered
                : this.state.documentosReporte;

        const newOffset = (event.selected * itemsPerPage) % Math.max(base.length, 1);
        this.setState({ itemOffset: newOffset }, this.paginar);
    };

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">

                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="back-istmas">
                        <i className="fa fa-file-alt bounce-custom fs-5"></i>
                        <b className="ms-2">Documentos de prácticas laborales</b>
                    </div>

                    {/* Buscador y Filtro */}
                    <div className="row mt-3">
                        <div className="col-12 col-sm-12 col-lg-5 text-azul">
                            <label><b><i className="fa-magnifying-glass"></i> Buscar:</b></label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                value={this.state.textBuscar || ""}
                                placeholder="Buscar..."
                                onChange={(e) => this.filter(e)}
                            />
                        </div>
                        <div className="col-12 col-sm-12 col-lg-5 text-azul">
                            <label><b>Carrera para los documentos</b></label>
                            <select
                                className="form-select form-select-sm"
                                onChange={(e) => {
                                    const id = e.target.value;
                                    this.setState({ carreraSeleccionada: id });
                                    if (id) this.reporteDocumentos(id);
                                    else this.setState({ documentosReporte: [], currentItems: [], pageCount: 0 });
                                }}
                            >
                                <option value="">Seleccione una carrera</option>
                                {this.state.carreras.map((c) => (
                                    <option key={c.id_carrera} value={c.id_carrera}>
                                        {c.descripcion_carrera}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Tabla */}
                    {this.state.carreraSeleccionada && (
                        <div className="card-body mt-3">
                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className="table-light">
                                        <tr className="text-azul text-start">
                                            <th>Nombre</th>
                                            <th>Descripción</th>
                                            <th>Orden</th>
                                            <th>Archivo</th>
                                            <th>Estado</th>
                                            <th>Carrera</th>
                                            <th>Modificar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.currentItems &&
                                            this.state.currentItems.map((doc) => (
                                                <tr className="text-azul text-start" key={doc.id}>
                                                    <td>{doc.nom_doc}</td>
                                                    <td>{doc.desc_doc}</td>
                                                    <td>{doc.orden_documento ? doc.orden_documento.num_orden : "-"}</td>
                                                    <td>
                                                        {doc.arch_doc && (
                                                            <a href={doc.ruta} target="_blank" rel="noreferrer">
                                                                <i className="fa fa-2x fa-file-alt text-primary"></i>
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td>


                                                        {(() => { switch (doc.estado) { case 0: return (<button className="badge bg-danger text-white px-2 py-1" style={{ borderRadius: "10px", fontSize: "0.75rem", border: "none", }} onClick={() => this.bttActDesac(doc)} > Inactivo </button>); case 1: return (<button className="badge bg-success text-white px-2 py-1" style={{ borderRadius: "10px", fontSize: "0.75rem", border: "none", }} onClick={() => this.bttActDesac(doc)} > Activo </button>); default: return ""; } })()}

                                                    </td>
                                                    <td>{doc.carrera ? doc.carrera.descripcion_carrera : "-"}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-link p-0"
                                                            onClick={() => this.mostrarModalModificarPractica(doc)}
                                                            title="Ver/Editar"
                                                        >
                                                            <i className="fas fa-pen text-azul bounce-custom"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        {/* ✅ MENSAJE SI NO HAY DATOS, PERO SÍ HAY CARRERA SELECCIONADA */}
                                        {this.state.currentItems && this.state.currentItems.length === 0 && (
                                            <tr>
                                                <td colSpan="7" className="text-center text-muted py-3">
                                                    No existen datos para la carrera seleccionada.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Paginación */}
                            <div className="d-flex justify-content-center mt-4 "> <ReactPaginate previousLabel="<" nextLabel=">" pageCount={this.state.pageCount} onPageChange={this.handlePageClick} containerClassName="pagination pagination-sm-custom" pageLinkClassName="page-link" previousClassName="page-item" previousLinkClassName="page-link" nextClassName="page-item" nextLinkClassName="page-link" activeClassName="active" /> </div>

                            {/* Botón Registrar */}
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                    onClick={this.mostrarModalRegistro}
                                >
                                    <i className="fas fa-plus me-1"></i>Registrar
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Modal Registro */}
                    <Modal isOpen={this.state.modalRegistro}>
                        <ModalHeader>Registrar Documento</ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <label>Orden</label>
                                <select
                                    className="form-select"
                                    value={this.state.ord_doc_id}
                                    onChange={(e) => this.setState({ ord_doc_id: e.target.value })}
                                >
                                    <option value="">Seleccione un orden</option>
                                    {this.state.ordendoclist.map((orden) => (
                                        <option key={orden.id_orden_documento} value={orden.id_orden_documento}>
                                            {orden.num_orden}
                                        </option>
                                    ))}
                                </select>

                                <label>Nombre</label>
                                <input type="text" className="form-control" onChange={(e) => this.setState({ nombre: e.target.value })} />

                                <label>Descripción</label>
                                <input type="text" className="form-control" onChange={(e) => this.setState({ descripcion: e.target.value })} />

                                <label>Archivo</label>
                                <input type="file" id="arch_doc" className="form-control" onChange={(e) => this.setState({ archivo: e.target.files[0] })} />
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={this.ingresarDocumento}>Registrar</Button>
                            <Button color="secondary" onClick={() => this.setState({ modalRegistro: false })}>Cancelar</Button>
                        </ModalFooter>
                    </Modal>

                    {/* Modal Modificar */}
                    <Modal isOpen={this.state.modalModificarPractica}>
                        <ModalHeader>Modificar Documento de Prácticas</ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <input type="hidden" value={this.state.idDocumentoMod} />

                                <label>Orden del documento</label>
                                <select
                                    className="form-select"
                                    value={this.state.idOrdenDocMod || ""}
                                    onChange={(e) => this.setState({ idOrdenDocMod: e.target.value })}
                                >
                                    <option value="" disabled>Seleccione orden</option>
                                    {this.state.ordendoclist.map((orden) => (
                                        <option key={orden.id_orden_documento} value={orden.id_orden_documento}>
                                            {orden.num_orden}
                                        </option>
                                    ))}
                                </select>

                                <label>Nombre</label>
                                <input type="text" className="form-control" value={this.state.nomDocumentMod || ""} onChange={(e) => this.setState({ nomDocumentMod: e.target.value })} />

                                <label>Descripción</label>
                                <input type="text" className="form-control" value={this.state.descripDocumentMod || ""} onChange={(e) => this.setState({ descripDocumentMod: e.target.value })} />

                                <label>Subir nuevo archivo (opcional)</label>
                                <input type="file" className="form-control" accept=".pdf,.doc,.docx" onChange={(e) => this.setState({ documentoMod: e.target.files[0] })} />
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={this.modificarDocumentoPractica}>Guardar</Button>
                            <Button color="secondary" onClick={() => this.setState({ modalModificarPractica: false })}>Cancelar</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        );
    }
}
